// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ProjectSummaryCompany {
  readonly companyId: string;
  readonly companyName: string;

  constructor(data: { [key: string]: any } = {}) {
    this.companyId = data.companyId === undefined ? NIL_UUID : data.companyId;
    this.companyName = data.companyName === undefined ? '' : data.companyName;
  }

  static zero(): ProjectSummaryCompany {
    const zeroValues: ExcludeMethodsDeep<ProjectSummaryCompany> = {
      companyId: NIL_UUID,
      companyName: '',
    };
    return new ProjectSummaryCompany(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectSummaryCompanyWireFormat = {
  companyId: string;
  companyName: string;
};

type NewProjectSummaryCompanyProps = PartialDeep<
  ProjectSummaryCompany,
  { recurseIntoArrays: true }
>;
export const NewProjectSummaryCompany: (
  props: NewProjectSummaryCompanyProps,
) => ProjectSummaryCompany = (props) => new ProjectSummaryCompany(props);

type NewProjectSummaryCompanyFromWireFormatProps = PartialDeep<
  ProjectSummaryCompanyWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectSummaryCompanyFromWireFormat: (
  props: NewProjectSummaryCompanyFromWireFormatProps,
) => ProjectSummaryCompany = (props) => new ProjectSummaryCompany(props);
